import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Apify, ApifyFullScreenLoadingComponent } from '../Apify';
import { StockCard } from '../c/ChartCard';
import { T } from '../traks';
import SearchField from '../c/SearchField';
import { PortfolioWithResolve } from '../c/Portfolio';

const G = (props) => props.children;

var ExploreBANK = (props) => {
	var sections = [];

	sections.push(
		<Container key="this_is_the_unique_key_for_the_currency_portfolio_container" className="pb-3">
		<Row key="this_is_the_unique_key_for_the_currency_title_row">
			<Col xs="12" className="pb-3">
				<h3 className="pt-5"><T>All currencies</T></h3>
			</Col>
		</Row>
		<Row key="this_is_the_unique_key_for_the_currency_portfolio_row" className="ad_notification_box">
			<Col md="12">
				<PortfolioWithResolve show_title={false} include_chart={false} portfolio_id={161}/>
			</Col>
		</Row>
		</Container>
	);

	for (const section of props.home.Sections) {
		var items = [];

		const mk_stock_item = (asset) => {
			const key = `STOCK:${asset.Exchange}:${asset.Ticker}`;
			return (
				<Col key={key} md="3" className="pb-4">
					<StockCard
						exchange={asset.Exchange}
						ticker={asset.Ticker}
						range="3m"
					/>
				</Col>
			);
		};

		switch (section.Type) {
			case "STOCKS":
				items = section.Content.map(mk_stock_item);
				break;
			default:
				continue;
		}
		sections.push(
				<span key="SPANNING_ALL">
				<Row key={section.Type}>
					<Col xs="12" className="pb-3">
						<h3><T>Random currencies</T></h3>
					</Col>
				</Row>
				<Row>
					{items}
				</Row>
				</span>
		);
	}

	const placeholder = <T>Search currencies</T>;

	return (
		<G>
			<div className="d-flex flex-column text-center ad_explore_large_img_bank justify-content-center">
				<div className="pt-5 text-white ad_explore_txt_header"><T>Currencies</T></div>
				<div className="text-white pb-3 ad_explore_txt_subheader px-2"><T>Explore our supported currencies</T></div>
				<SearchField placeholder={placeholder} market="FOREX" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

ExploreBANK = Apify("/z/explore?market=FOREX")
	.with_response_prop("home")
	.wrap(ExploreBANK, ApifyFullScreenLoadingComponent);

export default ExploreBANK;



// WEBPACK FOOTER //
// ./src/p/ExploreBANK.js